import styles from './LoginVerify.module.scss';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from '../../context/UserContext';
import { Input } from '../Shared/Input/Input';
import { GreenButton } from '../Shared/GreenButton/GreenButton';
import { API_URL } from '../../constants';
import { onlyNumbers } from '../../helpers/onlyNumbers';

export const LoginVerify = () => {
    const navigate = useNavigate();
    const [code, setCode] = useState('');
    const [errorCode, setCodeError] = useState(false);
    const { userState } = useUserContext();

    const [isLoading, setLoading] = useState<boolean>(false);

    const onChangeCode = (e: React.SyntheticEvent<EventTarget>) => {
        let code = (e.target as HTMLInputElement).value.replace(' ', '') ?? '';
        if (code.length > 7) return null;
        if (code.length > 3) code = `${code.slice(0, 3)} ${code.slice(3, 6)}`;
        setCode(code);
    };

    useEffect(() => {
        if (!userState) navigate('/login');
    }, []);

    const logIn = async () => {
        console.log('userState', userState);
        const trimmedCode = code.replace(' ', '');

        try {
            setLoading(true);
            const res = await userState?.confirmation.confirm(trimmedCode);
            const token = await res.user.getIdToken();
            console.log('token', token);
            axios.defaults.baseURL = API_URL;
            axios.defaults.headers.common = {
                Authorization: `bearer ${token}`,
            };
            setLoading(false);
            navigate('/');
        } catch (error) {
            console.log('error', error);
            setCodeError(true);
            setLoading(false);
            setCode('');
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.title}>Log in to Admin panel</div>
            <div className={styles.subTitle}>Please enter the code we sent you</div>
            <div className={styles.loginBox}>
                <div className={[styles.inputBox, errorCode && styles.inputBoxError].join(' ')}>
                    <Input
                        onKeyPress={onlyNumbers}
                        placeholder="000 000"
                        value={code}
                        type="text"
                        onChange={onChangeCode}
                    />
                </div>
                <GreenButton disabled={isLoading} onClick={logIn}>
                    Log in
                </GreenButton>
            </div>
        </div>
    );
};
